export default __webpack_public_path__ + "static/dearselfheader-206b06a38ce206bebb47309783a3cd1b.png";